<template>
	<div class="modal is-active">
		<div class="modal-background"></div>
		<div class="modal-card">
			<header class="modal-card-head">
				<p class="modal-card-title" >SOLICITAR ORÇAMENTO	</p>
				<button class="delete" aria-label="close" @click="goBack"></button>
			</header>
			<form @submit.prevent="onSubmit()" v-show="!isloading">

				<section class="modal-card-body" >

					<fieldset>
						<legend>DADOS DO ANUNCIANTE</legend>

						<div class="field">
							<div class="control">
								<input class="input" type="text" v-model="nome" required placeholder="Nome">
							</div>
						</div>

						<div class="field">
							<div class="control">
								<input class="input" type="text" v-model="email" required placeholder="E-mail">
							</div>
						</div>
						<div class="field">
							<div class="control">
								<input class="input" type="text" v-model="empresa" required placeholder="Empresa">
							</div>
						</div>

						<div class="field">
							<div class="control">
								<select class="input" v-model="categoria" required>
									<option value="">CATEGORIA DO SERVIÇO</option>
									<option value="Favoritos">Favoritos</option>
									<option value="Redes Sociais">Redes Sociais</option>
									<option value="Notícias">Notícias</option>
									<option value="Plataformas de Filmes e Vídeos">Plataformas de Filmes e Vídeos</option>
									<option value="Educação">Educação</option>
									<option value="Música">Música</option>
									<option value="Compras/ Locações e Negócios">Compras/ Locações e Negócios</option>
									<option value="Finanças">Finanças</option>
									<option value="Utilidades">Utilidades</option>
									<option value="Blogs">Blogs</option>
									<option value="Canais do Youtube">Canais do Youtube</option>
									<option value="Alimentação/ restaurantes">Alimentação/ restaurantes</option>
								</select>
							</div>
						</div>
					</fieldset>


					<fieldset>
						<legend>DADOS DA CAMPANHA (ANÚNCIO)</legend>

						<div class="field">
							<div class="control">
								<input class="input" type="text" v-model="pais" required placeholder="PAÍS">
							</div>
						</div>
						<div class="field">
							<div class="control">
								<input class="input" type="text" v-model="estado" required placeholder="ESTADO">
							</div>
						</div>
						<div class="field">
							<div class="control">
								<input class="input" type="text" v-model="data_inicio" required placeholder="DATA DE INÍCIO">
							</div>
						</div>
						<div class="field">
							<div class="control">
								<input class="input" type="text" v-model="data_termino" required placeholder="DATA DE TÉRMINO">
							</div>
						</div>
						<div class="field">
							<div class="control">
								<input class="input" type="text" v-model="tempo" required placeholder="TEMPO TOTAL (MIN 1 MÊS)">
							</div>
						</div>
					</fieldset>


						<div v-show="alertSuccess" class="notification is-success">
							Mensagem enviada com sucesso.
						</div>


				</section>

				<footer class="modal-card-foot">
					<button type="submit" class="button is-success">Salvar</button>
					<button class="button" @click.prevent="goBack">Cancelar</button>
				</footer>

			</form>
			<div class="modal-card-body" v-if="isloading">Carregando</div>
		</div>
	</div>
</template>

<style>


fieldset + fieldset {
  margin-top: 15px;
}
fieldset legend{
  text-align: center;
  margin-bottom: 10px;
}


</style>

<script>

export default {
	data() {
		return {
			nome: '',
			email: '',
			empresa: '',
			categoria: '',
			pais: '',
			estado: '',
			data_inicio: '',
			data_termino: '',
			tempo: '',
			isloading:false,
			alertSuccess:false,
		}
	},
	computed: {
		userId() {
			return this.$store.getters.userId;
		},
	},
	methods:{
		goBack(){
			this.$router.push({name:'home'});
		},
		onSubmit(){
			console.log('submit');

			var data = {
				to:'fernando@urlinx.com.br',
				// to:'giannoulakis@gmail.com',
				subject:'Novo orçamento',
				body:'',
			}

			data.body += 'Nome: '+this.nome+'<br>'+"\n";
			data.body += 'Email: '+this.email+'<br>'+"\n";
			data.body += 'Empresa: '+this.empresa+'<br>'+"\n";
			data.body += 'Categoria: '+this.categoria+'<br>'+"\n";
			data.body += 'País: '+this.pais+'<br>'+"\n";
			data.body += 'Estado: '+this.estado+'<br>'+"\n";
			data.body += 'Data início: '+this.data_inicio+'<br>'+"\n";
			data.body += 'Data término: '+this.data_termino+'<br>'+"\n";
			data.body += 'Tempo: '+this.tempo+'<br>'+"\n";

			this.$http.get('https://api.scaalar.com/smtp/index.php',{params:data}).then((res)=>{
				console.log(res);
			}).catch((erro)=>{
				console.log(erro);
			});

			this.alertSuccess = true;

			this.nome =  '';
			this.email =  '';
			this.empresa =  '';
			this.categoria =  '';
			this.pais =  '';
			this.estado =  '';
			this.data_inicio =  '';
			this.data_termino =  '';
			this.tempo =  '';

		},
	},
	mounted() {

	},
};
</script>

